import {Component} from '@angular/core';
import {ApiHealthCenterResponse} from '../services/http/api-health-center-response';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'xp-health-center-details',
  templateUrl: './health-center-details.component.html',
  styleUrls: ['../../crud.common.scss', './health-center-details.component.scss'],
})
export class HealthCenterDetailsComponent {


  public healthCenter: ApiHealthCenterResponse | null = null;

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
  ) {
    this._activatedRoute.data.subscribe(({healthCenter}) => {
      this.healthCenter = healthCenter as ApiHealthCenterResponse;
    });
  }

}
